'use client';

import { useCallback, useEffect, useState } from 'react';
import { collectionApi } from '../api';
import { CollectionProducts } from '../api-client';

export const useProductsByCollection = (collectionId: number) => {
    const [collection, setCollection] = useState<CollectionProducts | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<unknown>(null);

    const getProducts = useCallback(async (): Promise<CollectionProducts | null> => {
        setLoading(true);
        setError(null);

        try {
            const { data } = await collectionApi.productsCollectionsProductsRetrieve({ id: collectionId });
            setCollection(data ?? null);
            return data ?? null;
        } catch (err) {
            setError(err);
            setCollection(null);
            console.error('Error al obtener productos de la colección:', err);
            return null;
        } finally {
            setLoading(false);
        }
    }, [collectionId]);

    useEffect(() => {
        void getProducts();
    }, [getProducts]);

    return {
        collection,
        products: collection?.products ?? [],
        getProducts,
        loading,
        error,
    };
};

